import React from "react";
import { Button, CopyIcon } from "@pd/pd-ui-kit";
import { TableV2 } from "~/shared/ui/TableV2";
import { useForm } from "react-hook-form";
import TextArea from "~/shared/ui/Fields/TextArea";
import { LICENSES } from "../options";
import s from "../RegisterOfDocuments.less";

export const SeeCode = ({
  isLoadingLicenses,
  codeList,
  handleCopy,
  closeModal,
}: any) => {
  return (
    <div className={s.wrapperCodeList}>
      <TableV2
        dataSource={codeList}
        type="list_license"
        options={LICENSES}
        loading={isLoadingLicenses}
        wrapperClassName={s.licenses}
        noHorizontalScroll
      />
      {!isLoadingLicenses && (
        <>
          <div className={s.seeCodeWrappButton}>
            <Button
              onClick={handleCopy}
              icon={<CopyIcon size={16} fill="#495A64" viewBox="0 0 16 16" />}
              iconPosition="start"
              color="secondary"
              variant="filled"
              radius="30"
              fontSize="14"
              size="middle"
            >
              Скопировать
            </Button>
          </div>
          <div className={s.hrLine} />
          <div className={s.seeCodeClose}>
            <Button color="secondary" onClick={closeModal}>
              Закрыть
            </Button>
          </div>
        </>
      )}
    </div>
  );
};

interface SendAcceptActIProps {
  closeModal: () => void;
  nextStep?: boolean;
  handleStep: () => void;
  sendDeacceptAct: (prop: string) => void;
}

export const SendDeacceptAct = ({
  closeModal,
  nextStep,
  handleStep,
  sendDeacceptAct,
}: SendAcceptActIProps) => {
  const { control, handleSubmit, reset } = useForm<{ comment: string }>({
    defaultValues: { comment: "" },
  });

  const onSubmit = ({ comment }: { comment: string }) => {
    sendDeacceptAct(comment);
    reset();
  };

  return (
    <>
      {nextStep ? (
        <form onSubmit={handleSubmit(onSubmit)} className={s.formModal}>
          <TextArea
            placeholder="Комментарий"
            customClassName={s.textComment}
            control={control}
            name="comment"
          />
          <div className={s.sendButtonGroup}>
            <Button
              onClick={handleStep}
              color="secondary"
              fontSize="18"
              size="large"
              htmlType="button"
            >
              Отмена
            </Button>
            <Button
              color="primary"
              fontSize="18"
              size="large"
              htmlType="submit"
            >
              Отправить
            </Button>
          </div>
        </form>
      ) : (
        <div className={s.sendButtonGroup}>
          <Button
            onClick={closeModal}
            color="secondary"
            fontSize="18"
            size="large"
          >
            Отмена
          </Button>
          <Button
            onClick={handleStep}
            color="primary"
            fontSize="18"
            size="large"
          >
            Да, отклонить
          </Button>
        </div>
      )}
    </>
  );
};

export const SendAcceptAct = ({
  closeModal,
  sendAcceptAct,
}: {
  closeModal: () => void;
  sendAcceptAct: () => void;
}) => {
  return (
    <div className={s.sendButtonGroup}>
      <Button onClick={closeModal} color="secondary" fontSize="18" size="large">
        Отмена
      </Button>
      <Button
        onClick={sendAcceptAct}
        color="primary"
        fontSize="18"
        size="large"
      >
        Да, отправить коды
      </Button>
    </div>
  );
};
